<template>
  <div class="opus-root-container">
    <!-- loading -->
    <van-overlay :show="loading" @click="loading = false" style="z-index:12">
      <div class="wrapper" @click.stop>
        <van-loading type="spinner" class="row" style="align-items:center" />
      </div>
    </van-overlay>

    <!-- header -->
    <navigation-bar title="作品详情页" />

    <!-- 内容 -->
    <div class="opus-container">
      <div class="opus-prize">{{ opusDetail.tag_arr[0].name }}</div>

      <div class="opus-name" style="margin-top: 0.15rem">{{ opusDetail.name }}</div>

      <div class="divider" style="margin: 0.15rem -0.15rem"></div>

      <van-sticky :offset-top="57">
        <div class="opus-tabbar-root-container">
          <div v-for="(item, index) in tabbarList" :key="index" :class="[
            'opus-tabbar-item-container',
            index == currentTabbarIndex ? ' opus-tabbar-current' : '',
          ]" @click="currentTabbarIndex = index">
            <div class="column" style="align-items: center">
              <a :class="[
                'single-text',
                index == currentTabbarIndex
                  ? 'opus-current-tab'
                  : 'opus-normal-tab',
              ]" :href="item.anchor">
                {{ item.name }}
              </a>
              <div style="margin-top: 0.05rem" :class="[
                index == currentTabbarIndex ? 'block-current' : 'block-normal',
              ]"></div>
            </div>
          </div>
        </div>
      </van-sticky>

      <div class="opus-title row" style="margin-top: 0.2rem">
        <div id="opus-info" name="opus-info" style="margin-top: -3rem"></div>
        作品信息
      </div>
      <div class="column opus-info" style="margin-top: 0.1rem">
        <div style="margin-top: 0.05rem">注册号：{{ opusDetail.num }}</div>
        <div style="margin-top: 0.05rem">作&nbsp;&nbsp;者：{{ opusDetail.author }}</div>
        <div style="margin-top: 0.05rem">参赛单位：{{ opusDetail.company }}</div>
        <div style="margin-top: 0.05rem">指导教师：{{ opusDetail.teacher }}</div>
      </div>

      <div class="opus-title row" style="margin-top: 0.2rem">
        <div id="opus-professor" name="opus-professor" style="margin-top: -3rem"></div>
        专家点评
      </div>
      <div class="opus-professor-comment" style="margin-top: 0.15rem">
        {{ opusDetail.comment }}
      </div>

      <div class="opus-title row" style="margin-top: 0.2rem">
        <div id="opus-image" name="opus-image" style="margin-top: -3rem"></div>
        图片赏析
      </div>
      <div class="opus-image-container">
        <div class="row" style="justify-content: flex-start; margin-top: 0.15rem" v-for="(item, index) in imgFormats"
          :key="index">
          <template v-if="index == 0">
            <div class="div-background opus-image-large" :style="{
                backgroundImage: `url(${item[0].img_url})`,
              }" @click="preview(0)"></div>
            <div class="column" style="margin-left: 0.1rem">
              <div class="div-background opus-image-normal" style="margin-bottom: 0.1rem" :style="{
                  backgroundImage: `url(${item[1].img_url})`,
                }" @click="preview(1)"></div>
              <div class="div-background opus-image-normal" :style="{
                  backgroundImage: `url(${item[2].img_url})`,
                }" @click="preview(2)"></div>
            </div>
          </template>
          <template v-else>
            <div class="div-background opus-image-normal" v-for="(image, index2) in item" :key="image.id" :style="{
                backgroundImage: `url(${image.img_url})`,
                margin: index2 == 1 ? '0 0.1rem' : '',
              }" @click="preview(image.index)"></div>
          </template>
        </div>
      </div>

      <div class="opus-title row" style="margin-top: 0.2rem">
        <div id="opus-comment" name="opus-comment" style="margin-top: -3rem"></div>
        精彩评论
      </div>
      <div class="opus-comment-list column" style="margin-top: 0.15rem">
        <template v-if="opus_comment_list.length > 0">
          <div class="opus-comment column" v-for="item in opus_comment_list" :key="item.id">
            <div>{{ item.content }}</div>
            <div style="text-align: right; margin-top: 0.1rem">
              {{ item.create_time_format }}
            </div>
          </div>
          <div class="opus-loadmore row" style="margin: 0.15rem 0;align-self:center" @click="loadMore"
            v-if="opus_comment_total_count != opus_comment_list.length">
            点击加载更多
          </div>
          <div class="row" style="margin: 0.15rem 0" v-else>没有更多了</div>
        </template>
        <div v-else style="margin-bottom: 0.25rem">无</div>
      </div>

      <div style="height: 0.5rem"></div>
    </div>

    <div class="opus-comment-input-container">
      <input v-model="comment_content" type="text" class="opus-comment-input empty-input" style="flex: 1" />
      <div class="opus-comment-send row" style="margin-left: 0.1rem" @click="addComment">发送</div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
import "vant/lib/image-preview/style";
import * as type from "../store/type";
import NavigationBar from "@/components/NavigationBar";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    "navigation-bar": NavigationBar,
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  data() {
    return {
      loading: false,
      currentTabbarIndex: 0,
      comment_content: "",
      opusDetail: {
        author: "",
        comment: "",
        company: "",
        img_url_arr: "",
        name: "",
        num: "",
        opus_id: 0,
        orderby: 0,
        portfolio_id: 0,
        teacher: "",
        fullPathArr: [],
        tag_arr: [{}],
      },
      tabbarList: [
        {
          id: 1,
          name: "作品信息",
          anchor: "#opus-info",
        },
        {
          id: 2,
          name: "专家点评",
          anchor: "#opus-professor",
        },
        {
          id: 3,
          name: "图片赏析",
          anchor: "#opus-image",
        },
        {
          id: 4,
          name: "精彩评论",
          anchor: "#opus-comment",
        },
      ],
    };
  },
  mounted() {
    this.opusDetail.opus_id = this.$router.currentRoute.params.opus_id;

    this.init();
    this.getDetail();
    this.getCommentList();
  },
  computed: {
    ...mapState({
      opus_comment_list: (state) => state.opus.opus_comment_list,
      opus_comment_page_size: (state) => state.opus.opus_comment_page_size,
      opus_comment_page_index: (state) => state.opus.opus_comment_page_index,
      opus_comment_total_count: (state) => state.opus.opus_comment_total_count,
    }),
    imgFormats() {
      let arr = [];
      for (let i = 0; i < this.opusDetail.fullPathArr.length; i += 3) {
        arr.push(this.opusDetail.fullPathArr.slice(i, i + 3));
      }
      return arr;
    },
  },
  methods: {
    ...mapActions({
      opusGetDetailAction: "opusGetDetail",
      opusAddCommentAction: "opusAddComment",
      opusGetCommentListAction: "opusGetCommentList",
    }),
    init() {
      this.$store.commit(type.CLEAR_OPUS_COMMENT_LIST);
      this.$store.commit(type.SET_OPUS_COMMENT_PAGE_INDEX, 0);
    },
    getDetail() {
      this.opusGetDetailAction({
        opus_id: this.opusDetail.opus_id,
      })
        .then((res) => {
          this.opusDetail = res;
        })
        .catch((error) => {
          console.error(error);
          alert(error);
        });
    },
    preview(index) {
      let img_url_arr = this.opusDetail.fullPathArr.map((item) => {
        return item.img_url;
      });
      ImagePreview({
        images: img_url_arr,
        startPosition: index,
        maxZoom: 1,
        minZoom: 1,
      });
    },
    getCommentList() {
      this.opusGetCommentListAction({
        page_size: this.opus_comment_page_size,
        page_index: this.opus_comment_page_index,
        opus_id: this.opusDetail.opus_id,
      })
        .then((res) => {})
        .catch((error) => {
          console.error(error);
          alert(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addComment() {
      if (this.loading) {
        return;
      }
      if (this.comment_content == "") {
        alert("请输入评论内容");
        return;
      }
      this.loading = true;
      this.opusAddCommentAction({
        opus_id: this.opusDetail.opus_id,
        content: this.comment_content,
      })
        .then((res) => {
          this.comment_content = "";
          alert("评论成功");
          this.init();
          this.getCommentList();
        })
        .catch((error) => {
          console.error(error);
          alert(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadMore() {
      if (this.loading) {
        return;
      }
      this.$store.commit(
        type.SET_OPUS_COMMENT_PAGE_INDEX,
        this.opus_comment_page_index + 1
      );
      this.getCommentList();
    },
  },
};
</script>

<style scoped>
.opus-container {
  margin-top: 0.68rem;
  padding: 0.15rem;
}
.opus-prize {
  font-family: PingFangSC-Semibold;
  font-size: 0.18rem;
  color: #282828;
  text-align: justify;
}
.opus-name {
  font-family: PingFangSC-Regular;
  font-size: 0.14rem;
  color: #464646;
  text-align: justify;
}
.opus-tabbar-root-container {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  overflow-x: auto;
  overflow-y: hidden;
  background-color: white;
  padding: 0.15rem 0;
}
.opus-tabbar-item-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.24rem;
  margin-right: 0.15rem;
}
.opus-tabbar-item-container:last-child {
  margin-right: 0;
}
.block-current {
  width: 0.2rem;
  height: 0.03rem;
  transition: all 0.2s ease;
  background: #2ec7c2;
  border-radius: 2px;
}
.block-normal {
  width: 0.2rem;
  height: 0.03rem;
}
.opus-title {
  width: 0.7rem;
  background: #e6f5fa;
  border-radius: 5px;
  font-family: PingFangSC-Regular;
  font-size: 0.13rem;
  color: #282828;
  padding: 0.05rem;
}
.opus-info {
  font-family: PingFangSC-Regular;
  font-size: 0.13rem;
  color: #464646;
  text-align: justify;
}
.opus-professor-comment {
  font-family: PingFangSC-Regular;
  font-size: 0.13rem;
  color: #464646;
  text-align: justify;
}
.opus-comment {
  font-family: PingFangSC-Regular;
  font-size: 0.13rem;
  color: #464646;
  text-align: justify;
  border-bottom: 1px solid #c6c6c6;
  padding-bottom: 0.15rem;
  margin-bottom: 0.15rem;
}
.opus-comment:last-child {
  border-bottom: none;
}
.opus-comment-input-container {
  position: fixed;
  height: 0.45rem;
  left: 0;
  right: 0;
  bottom: 0;
  border-top: 1px solid #f4f4f4;
  border-bottom: 1px solid #f4f4f4;
  background-color: white;
  padding: 0.1rem 0.15rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: PingFangSC-Regular;
  font-size: 0.12rem;
}
.opus-comment-input {
  background: #f9f9f9;
  border-radius: 15px;
  height: 0.3rem;
  padding: 0 0.15rem;
}
.opus-comment-send {
  background: #2ec7c2;
  border-radius: 5px;
  width: 0.55rem;
  height: 0.3rem;
  color: white;
}
.opus-current-tab {
  font-family: PingFangSC-Semibold;
  font-size: 0.14rem;
  color: #282828;
  text-align: justify;
  text-decoration: none;
}
.opus-normal-tab {
  font-family: PingFangSC-Regular;
  font-size: 0.13rem;
  color: #282828;
  letter-spacing: 0;
  text-decoration: none;
}
.opus-image-large {
  width: 2rem;
  height: 2rem;
}
.opus-image-normal {
  width: 0.95rem;
  height: 0.95rem;
}
.opus-loadmore {
  width: 1.2rem;
  height: 0.4rem;
  background: #efefef;
  border-radius: 10px;
  align-self: center;
}
</style>